import React from "react";

const ImagePreview = (props) => {
  return (
    <>
      <div className="img-preview-box center" onClick={() => props.delete(props.id)}>
        <img src={props.path} alt="プレビュー画像" />
      </div>
      <div className="spacer-box--s" />
    </>
  );
};

export default ImagePreview;
